import { openArticleInMessenger } from 'entities/WebMcp/lib/handoffToMessenger'

export type OpenArticleResult = { opened: boolean; via: 'messenger' | 'browser' | null }

/**
 * Open a help article for the user. Prefers the in-app messenger (reads without
 * leaving the app); when the messenger is unavailable — localhost, a HIPAA
 * session, or not booted — falls back to opening the public article URL in a new
 * browser tab. Returns not-opened only when neither path is possible.
 */
export const openHelpArticleView = (articleId: string, url?: string): OpenArticleResult => {
  if (openArticleInMessenger(articleId)) {
    return { opened: true, via: 'messenger' }
  }
  if (url) {
    window.open(url, '_blank', 'noopener,noreferrer')
    return { opened: true, via: 'browser' }
  }
  return { opened: false, via: null }
}
